import Axios from "axios";
import {
  SET_CHANGES_IN_EQUITY_REPORT,
  UNSET_CHANGES_IN_EQUITY_REPORT,
} from "@/store/mutation-types";
import {
  getChangesInEquityReport,
} from "@/store/api";

const state = {
  changesInEquityReport: [],
};

const getters = {
  getChangesInEquityReport(state) {
    return state.changesInEquityReport;
  },
};

const mutations = {
  [SET_CHANGES_IN_EQUITY_REPORT](state, data) {
    state.changesInEquityReport = data;
  },
  [UNSET_CHANGES_IN_EQUITY_REPORT](state) {
    state.changesInEquityReport = [];
  },
};

const actions = {
  getChangesInEquity({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.get(`${getChangesInEquityReport}`, { params: data })
        .then((response) => {
          commit(SET_CHANGES_IN_EQUITY_REPORT, response.data.data || []);
          resolve(response.data);
        })
        .catch((error) => {
          commit(UNSET_CHANGES_IN_EQUITY_REPORT);
          reject(error);
        })
        .finally(() => {
          commit("UNSET_LOADING", null, { root: true });
        });
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};

